import { ITaskForCalendar } from '@/bundles/Tasks/interfaces/ITask';
import { TaskAssigneePrivacyEnum } from '@/bundles/Tasks/types';
import { Task } from '@/bundles/Tasks/models/Task';

export class TaskForCalendar extends Task implements ITaskForCalendar {
  assignee_privacy: TaskAssigneePrivacyEnum;

  constructor (payload: ITaskForCalendar) {
    super(payload);
    this.assignee_privacy = payload.assignee_privacy;
  }
}
